var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddtitleblock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15422_70874)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.0587,
    stroke: "#909090",
    strokeWidth: 1.88269
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4004 13.6406H27.041V15.4004H24.4004V18.041H22.6406V15.4004H20V13.6406H22.6406V11H24.4004V13.6406Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 11,
    width: 5,
    height: 13,
    transform: "rotate(90 18 11)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 17,
    width: 2,
    height: 13,
    transform: "rotate(90 18 17)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 20,
    width: 2,
    height: 10,
    transform: "rotate(90 15 20)",
    fill: "#909090"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15422_70874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtitleblock);
export default __webpack_public_path__ + "static/media/addtitleblock.a5bd956a.svg";
export { ForwardRef as ReactComponent };var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddtitleblock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15422_70874)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.0587,
    stroke: "#909090",
    strokeWidth: 1.88269
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4004 13.6406H27.041V15.4004H24.4004V18.041H22.6406V15.4004H20V13.6406H22.6406V11H24.4004V13.6406Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 11,
    width: 5,
    height: 13,
    transform: "rotate(90 18 11)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 17,
    width: 2,
    height: 13,
    transform: "rotate(90 18 17)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 20,
    width: 2,
    height: 10,
    transform: "rotate(90 15 20)",
    fill: "#909090"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15422_70874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtitleblock);
export default __webpack_public_path__ + "static/media/addtitleblock.a5bd956a.svg";
export { ForwardRef as ReactComponent };